import { useAuth } from "../contexts/auth";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedLayout() {
    const { signed } = useAuth();

    if (!signed) {
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};
